import { IPaginationDTO, ISubmissionDTO, ITeamDTO, IUserDTO } from '@/dtos';
import { get, post, remove, generatePagination } from '@/services/apiWrapper';

export const getAllTeamsAPI = async (
  pagination: IPaginationDTO,
): Promise<{ data: ITeamDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const teams = await get<{ data: ITeamDTO[]; count: number }>(`/admin/teams${pageOptions}`);
  return teams;
};

export const getTeamById = async (id: string, yearId?: string): Promise<ITeamDTO> => {
  let param = '';
  if (yearId) {
    param = `?year=${yearId}`;
  }
  const team = await get<ITeamDTO>(`/admin/teams/${id}${param}`);
  return team;
};

export const getSubmissionAPI = async (teamId: string, yearId: string): Promise<ISubmissionDTO> => {
  let param = '';
  if (yearId) {
    param = `?year=${yearId}`;
  }
  const team = await get<ISubmissionDTO>(`/admin/teams/${teamId}/submission${param}`);
  return team;
};

export const updateTeamLeadAPI = async (
  teamId: string,
  yearId: string,
  userId: string,
  updateTeam: boolean,
): Promise<IUserDTO> => {
  const body = { yearId: yearId, userId: userId, updateTeam: updateTeam };
  const lead = await post<IUserDTO>(`/admin/teams/${teamId}/lead`, body);
  return lead;
};

export const saveTeamAPI = async (team: ITeamDTO): Promise<ITeamDTO> => {
  const ret = await post<ITeamDTO>(`/admin/teams/${team.id}/save`, team);
  return ret;
};

export const createTeamAPI = async (team: ITeamDTO): Promise<ITeamDTO> => {
  const ret = await post<ITeamDTO>(`/admin/teams/createTeam`, team);
  return ret;
};

export const deleteTeamAPI = async (teamId: string): Promise<boolean> => {
  const team = await remove<boolean>(`/admin/teams/${teamId}`);
  return team;
};

export const getTeamMembersAPI = async (body: any) => {
  const pageOptions = await generatePagination(body.pageOptions);
  const teamMembers = await get(`/admin/teams/${body.teamId}/members/${body.yearId}${pageOptions}`);
  return teamMembers;
};

export const getPossibleUsersAPI = async (
  pagination: IPaginationDTO,
): Promise<{ data: IUserDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const possibleUser = await get<{ data: IUserDTO[]; count: number }>(`/admin/users${pageOptions}`);
  return possibleUser;
};

export const getTeamLevelsAPI = async () => {
  const user = await get(`/admin/teamslevels`);
  return user;
};

export const changeTeamLevelAPI = async (yearId: string, teamId: string, value: any) => {
  const level = post(`/admin/teams/${teamId}/year/${yearId}/level`, { value: value });
  return level;
};

export const teamCheckInAPI = async (teamId: string, yearId: string): Promise<boolean> => {
  const ret = await post<boolean>(`/admin/teams/${teamId}/year/${yearId}/checkIn`);
  return ret;
};

export const teamCheckOutAPI = async (teamId: string, yearId: string): Promise<boolean> => {
  const ret = await post<boolean>(`/admin/teams/${teamId}/year/${yearId}/checkOut`);
  return ret;
};

export const setTeamRemoteStatusAPI = async (teamId: string, yearId: string, isPerson: any) => {
  await post(`/admin/teams/${teamId}/year/${yearId}/inperson`, { isPerson: isPerson });
};

export const updateTeamRegistrationAPI = async (
  teamId: string,
  yearId: string,
  registration: any,
) => {
  await post(`/admin/teams/${teamId}/year/${yearId}/updateReg`, registration);
};
export const removeTeamMemberFromYearAPI = async (body: any) => {
  await remove(`/admin/teams/${body.teamId}/year/${body.yearId}/member/${body.removeId}`);
};

export const updateBranchForTeamAPI = async (
  teamId: string,
  yearId: string,
  branchId: string,
): Promise<void> => {
  await post(`/admins/teams/${teamId}/year/${yearId}/changeBranch`, { branchId: branchId });
};
